<template>
    <div>
        <van-loading vertical v-if="loading"/>
        <van-row v-if="!loading">
            <van-col span="6">
                <van-sidebar v-model="activeKey">
                    <van-sidebar-item v-for="(item, key) in recommend" :title="item.name" :key="key" @click="change(item)"/>
                </van-sidebar>
            </van-col>
            <van-col span="18">
                <van-grid :column-num="3" square>
                    <van-grid-item v-for="item in cls1data" @click="goDetail(item)" :key="item.id" :icon="item.img_url" :text="item.name" />
                </van-grid>
            </van-col>
        </van-row>
    </div>
</template>

<script>
import { ClsApi } from '@/api/market'
import { Row, Col, Sidebar, SidebarItem, Grid, GridItem, Loading } from 'vant';

export default {
    components: {
        [Row.name]: Row,
        [Col.name]: Col,
        [Sidebar.name]: Sidebar,
        [SidebarItem.name]: SidebarItem,
        [Grid.name]: Grid,
        [GridItem.name]: GridItem,
        [Loading.name]: Loading
    },
    data() {
        return {
            activeKey: null,
            clsdata: [],
            recommend: [{
                name: '全部',
                id: null
            }],
            cls1data: [],
            activeName: '全部',
            id: this.$route.params.id,
            loading: false
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            this.loading = true
            var that = this
            // 获取分类
            this.axios.get(ClsApi).then((ret) => {
                that.loading = false
                that.clsdata = ret
                const cls = that.clsdata.filter((it) => it.parent === null)
                for (var i = 0; i < cls.length; i++) {
                    that.recommend.push({id: ret[i].id, name: ret[i].name})
                }
                if (that.id) {
                    const _curcls = that.clsdata.filter((it) => it.id === this.id)
                    if (_curcls.length > 0) {
                    that.activeName = _curcls[0].name
                    }
                }
                if (that.id) {
                    that.cls1data = that.clsdata.filter((it) => it.parent === that.id)
                } else {
                    that.cls1data = that.clsdata.filter((it) => it.parent != null)
                }
                that.cls1data = that.clsdata.filter((it) => it.parent != null)
            }).catch(function (error) {
            console.log(error)
            })
        },
        change(item) {
            if (item.id) {
                this.cls1data = this.clsdata.filter((itm) => itm.parent === item.id)
            } else {
                this.cls1data = this.clsdata.filter((itm) => itm.parent !== null)
            }
        },
        onChange(index) {
            const itm = this.recommend[index]
            if (itm.id) {
                this.cls1data = this.clsdata.filter((itm) => itm.parent === itm.id)
            } else {
                this.cls1data = this.clsdata.filter((itm) => itm.parent !== null)
            }
        },
        goDetail (item) {
            const data = {
                cls1: item.id
            }
            this.$router.push({
                name: 'result',
                query: JSON.stringify(data)
            })
        }
    }
}
</script>